import React, { useState } from 'react';
import { CalendarPlus, Copy, Check, Download } from 'lucide-react';
import { useT } from '../../services/i18n';

// "Add to my calendar" card: iCal subscription URL + instructions for Google / Outlook / Apple
const CalendarFeedCard = ({ icalPath, compact = false }) => {
  const { t } = useT();
  const [copied, setCopied] = useState(false);
  if (!icalPath) return null;
  const url = `${window.location.origin}${icalPath}`;
  const webcal = url.replace(/^https?:/, 'webcal:');
  const copy = () => navigator.clipboard?.writeText(url).then(() => { setCopied(true); setTimeout(() => setCopied(false), 2000); });
  return (
    <div className={`rounded-lg border border-sky-200 bg-sky-50/50 ${compact ? 'p-3' : 'p-4'}`} data-testid="calendar-feed-card">
      <p className="text-sm font-semibold text-gray-900 inline-flex items-center gap-1.5"><CalendarPlus size={15} className="text-sky-600" /> {t('ps.calTitle')}</p>
      <p className="text-xs text-gray-600 mt-1">{t('ps.calIntro')}</p>
      <div className="mt-2 flex flex-wrap items-center gap-2">
        <code className="text-[11px] bg-white border border-gray-200 rounded px-2 py-1 break-all" data-testid="calendar-feed-url">{url}</code>
        <button type="button" onClick={copy} className="inline-flex items-center gap-1 rounded border border-gray-300 bg-white px-2 py-1 text-xs text-gray-700 hover:bg-gray-50" data-testid="calendar-feed-copy">{copied ? <><Check size={12} className="text-green-600" /> {t('ps.copied')}</> : <><Copy size={12} /> {t('ps.copyLink')}</>}</button>
        <a href={webcal} className="inline-flex items-center gap-1 rounded bg-sky-600 px-2 py-1 text-xs font-semibold text-white hover:bg-sky-700" data-testid="calendar-feed-webcal"><CalendarPlus size={12} /> {t('ps.subscribe')}</a>
        <a href={url} download className="inline-flex items-center gap-1 text-xs text-sky-700 underline" data-testid="calendar-feed-download"><Download size={12} /> {t('ps.downloadIcs')}</a>
      </div>
      {!compact && (
        <ul className="mt-2 text-[11px] text-gray-600 space-y-0.5 list-disc pl-4">
          <li><strong>Google Agenda</strong> : {t('ps.calGoogle')}</li>
          <li><strong>Outlook</strong> : {t('ps.calOutlook')}</li>
          <li><strong>Apple Calendar</strong> : {t('ps.calApple')}</li>
        </ul>
      )}
    </div>
  );
};

export default CalendarFeedCard;
